import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "text-danger" }
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "text-danger" }
const _hoisted_22 = { class: "col-lg-6" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "text-danger" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { userUserPicStore } from "@/stores/data/user-pic";
import {
  UserPICDataPayload,
  UserPICDataResponse,
} from "@/types/interface/user-pic";
import { mapOptionMultiselect } from "@/utils/helper";
import { useUserStore } from "@/stores/master/user";
import { useRoleStore } from "@/stores/master/role";
import { usePositionStore } from "@/stores/master/position";
import { useDepartmentStore } from "@/stores/master/department";
import { useVesselStore } from "@/stores/master/vessel";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateUserPic',
  setup(__props) {

const idUserPic = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const userPicStore = userUserPicStore();
const detailUserPic = ref<UserPICDataResponse>();
const userStore = useUserStore();
const listUser = ref<any>();
const roleStore = useRoleStore();
const listRole = ref<any>();
const positionStore = usePositionStore();
const listPosition = ref<any>();
const departmentStore = useDepartmentStore();
const listDepartment = ref<any>();
const vesselStore = useVesselStore();
const listVessel = ref<any>();

const userSchema = zod
  .object({
    value: zod.number(),
    label: zod.string(),
  })
  .refine(
    (data) =>
      listUser.value.some(
        (code) => code.value === data.value && code.label === data.label
      ),
    {
      message: "Invalid user selected",
    }
  );

const roleSchema = zod
  .object({
    value: zod.number(),
    label: zod.string(),
  })
  .refine(
    (data) =>
      listRole.value.some(
        (code) => code.value === data.value && code.label === data.label
      ),
    {
      message: "Invalid role selected",
    }
  );

const jobSchema = zod
  .object({
    value: zod.number(),
    label: zod.string(),
  })
  .refine(
    (data) =>
      listPosition.value.some(
        (code) => code.value === data.value && code.label === data.label
      ),
    {
      message: "Invalid job selected",
    }
  );

const departmentSchema = zod
  .object({
    value: zod.number(),
    label: zod.string(),
  })
  .refine(
    (data) =>
      listDepartment.value.some(
        (code) => code.value === data.value && code.label === data.label
      ),
    {
      message: "Invalid department selected",
    }
  );

const vesselSchema = zod
  .object({
    value: zod.number(),
    label: zod.string(),
  })
  .refine(
    (data) =>
      listVessel.value.some(
        (code) => code.value === data.value && code.label === data.label
      ),
    {
      message: "Invalid vessel selected",
    }
  );

const validationSchema = toTypedSchema(
  zod.object({
    user_id: userSchema,
    role_id: roleSchema,
    job_id: jobSchema,
    department_id: departmentSchema,
    vessel_id: vesselSchema,
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: user_id } = useField<number>("user_id");
const { value: role_id } = useField<number>("role_id");
const { value: job_id } = useField<number>("job_id");
const { value: department_id } = useField<number>("department_id");
const { value: vessel_id } = useField<number>("vessel_id");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;

  const payloadUserPic: UserPICDataPayload = {
    user_id: user_id.value?.value,
    role_id: role_id.value?.value,
    job_id: job_id.value?.value,
    department_id: department_id.value?.value,
    vessel_id: vessel_id.value?.value,
  };

  const responseApi = ref<any>();

  if (isEdit.value == true) {
    responseApi.value = await userPicStore.dispatchUpdate(
      idUserPic.value,
      payloadUserPic
    );
  } else {
    responseApi.value = await userPicStore.dispatchCreate(payloadUserPic);
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "User PIC Successfully Updated"
          : "User PIC Successfully Added"
      );
      router.push("/data/user-pic");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadDetailUserPic = async () => {
  const { success, message } = await userPicStore.dispatchDetail(
    idUserPic.value
  );
  if (success) {
    detailUserPic.value = await userPicStore?.userPic?.data;
    user_id.value = mapOptionMultiselect(
      detailUserPic.value?.user,
      "id",
      "name"
    );
    job_id.value = mapOptionMultiselect(detailUserPic.value?.job, "id", "name");
    department_id.value = mapOptionMultiselect(
      detailUserPic.value?.department,
      "id",
      "name"
    );
    role_id.value = mapOptionMultiselect(
      detailUserPic.value?.role,
      "id",
      "name"
    );
    vessel_id.value = mapOptionMultiselect(
      detailUserPic.value?.vessel,
      "id",
      "name"
    );
  }
};

const loadListUser = async () => {
  const { success, message } = await userStore.dispatchGetUsers(1, 99);
  if (success) {
    listUser.value = mapOptionMultiselect(
      await userStore.users.items,
      "id",
      "name"
    );
  }
};

const loadListRole = async () => {
  const { success, message } = await roleStore.dispatchGetRoles(1, 99);
  if (success) {
    listRole.value = mapOptionMultiselect(
      await roleStore.roles.items,
      "id",
      "name"
    );
  }
};

const loadListPosition = async () => {
  const { success, message } = await positionStore.dispatchGetPositions(1, 99);
  if (success) {
    listPosition.value = mapOptionMultiselect(
      await positionStore.positions.items,
      "id",
      "name"
    );
  }
};

const loadListDepartment = async () => {
  const { success, message } = await departmentStore.dispatchGetDepartments(
    1,
    99
  );
  if (success) {
    listDepartment.value = mapOptionMultiselect(
      await departmentStore.departments.items,
      "id",
      "name"
    );
  }
};

const loadListVessel = async () => {
  const { success, message } = await vesselStore.dispatchGetAll(1, 99);
  if (success) {
    listVessel.value = mapOptionMultiselect(
      await vesselStore.vessels.items,
      "id",
      "name"
    );
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idUserPic.value = router.currentRoute.value.params.id.toString();
    loadDetailUserPic();
  }
  loadListUser();
  loadListRole();
  loadListPosition();
  loadListDepartment();
  loadListVessel();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create User PIC"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/data/user-pic"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List User PIC ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        for: "user_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("User "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(user_id),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(user_id) ? (user_id).value = $event : null)),
                          options: listUser.value,
                          placeholder: "Choose User"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).user_id), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", {
                        for: "role_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Role "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(role_id),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(role_id) ? (role_id).value = $event : null)),
                          options: listRole.value,
                          placeholder: "Choose Role"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).role_id), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[8] || (_cache[8] = _createElementVNode("label", {
                        for: "job_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Position "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(job_id),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(job_id) ? (job_id).value = $event : null)),
                          options: listPosition.value,
                          placeholder: "Choose Position"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(errors).job_id), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", {
                        for: "department_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Department "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(department_id),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(department_id) ? (department_id).value = $event : null)),
                          options: listDepartment.value,
                          placeholder: "Choose Department"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(errors).department_id), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", {
                        for: "vessel_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Vessel "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(vessel_id),
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(vessel_id) ? (vessel_id).value = $event : null)),
                          options: listVessel.value,
                          placeholder: "Choose Vessel"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(errors).vessel_id), 1)
                    ])
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})